import { useSelector } from 'react-redux';
import { useStrip } from '../../plot/hooks/useStrip';
import { ruler2dPointsSelector } from '../selectors/ruler2d.selectors';
import { Ruler2dResizeEdgeHandle, edges } from './Ruler2dResizeEdgeHandle';
import {
  Ruler2dResizeCornerHandle,
  corners,
} from './Ruler2dResizeCornerHandle';
import { Ruler2dInfo } from './Ruler2dInfo';
import { Ruler2dSquare } from './Ruler2dSquare';
import { useRuler2dDimensions } from '../hooks/useRuler2dDimensions';
import { Ruler2dLine } from './Ruler2dLine';

export const Ruler2d = () => {
  const { xScale } = useStrip();
  const points = useSelector(ruler2dPointsSelector);
  const { y, height } = useRuler2dDimensions();

  return (
    <>
      <Ruler2dInfo />
      <Ruler2dSquare />
      {edges.map((edge) => (
        <Ruler2dResizeEdgeHandle edge={edge} key={edge} />
      ))}
      {corners.map((corner) => (
        <Ruler2dResizeCornerHandle corner={corner} key={corner} />
      ))}
      {points.map((timestamp) => (
        <Ruler2dLine
          key={timestamp}
          x={xScale(timestamp)}
          y={y}
          height={height}
        />
      ))}
    </>
  );
};
